import { render, staticRenderFns } from "./taki.vue?vue&type=template&id=6ce5b42c&scoped=true"
import script from "./taki.vue?vue&type=script&lang=js"
export * from "./taki.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce5b42c",
  null
  
)

export default component.exports